var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeaking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_02",
    "data-name": 2,
    transform: "translate(-499 -56.076)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 112,
    height: 112,
    rx: 21,
    transform: "translate(499 56.076)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rumor",
    transform: "translate(526.139 74.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10556",
    "data-name": "Group 10556",
    transform: "translate(0 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10555",
    "data-name": "Group 10555",
    transform: "translate(46.585 30.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12616",
    "data-name": "Path 12616",
    d: "M458.509,276.852a1.691,1.691,0,0,0-2.391,2.392,8.454,8.454,0,0,1,0,11.957,1.691,1.691,0,1,0,2.39,2.393,11.836,11.836,0,0,0,0-16.742Z",
    transform: "translate(-450.838 -276.357)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12617",
    "data-name": "Path 12617",
    d: "M413.708,319.273a1.691,1.691,0,0,0,0,2.392,1.691,1.691,0,0,1,0,2.391,1.691,1.691,0,1,0,2.391,2.392,5.079,5.079,0,0,0,0-7.175A1.691,1.691,0,0,0,413.708,319.273Z",
    transform: "translate(-413.213 -313.995)",
    fill: "#6a75b9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12618",
    "data-name": "Path 12618",
    d: "M45.939,38.938,41.713,32.6V30.857A20.857,20.857,0,0,0,0,30.857v2.7A20.579,20.579,0,0,0,7.892,49.742V63.776a1.691,1.691,0,0,0,1.691,1.691H29.876a1.691,1.691,0,0,0,1.691-1.691v-5.3H36.64A5.079,5.079,0,0,0,41.713,53.4V51.15a1.691,1.691,0,0,0-.795-1.434L38.7,48.331l2.215-1.384a1.691,1.691,0,0,0,.795-1.434V42.323l3.229-.807a1.691,1.691,0,0,0,1-2.579Z",
    transform: "translate(0 -10)",
    fill: "#ffdecf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12619",
    "data-name": "Path 12619",
    d: "M210.082,38.938,205.857,32.6V30.857A20.88,20.88,0,0,0,185,10V65.467h9.019a1.691,1.691,0,0,0,1.691-1.691v-5.3h5.073a5.079,5.079,0,0,0,5.073-5.073V51.15a1.691,1.691,0,0,0-.795-1.434l-2.215-1.384,2.215-1.384a1.691,1.691,0,0,0,.795-1.434V42.323l3.229-.807A1.691,1.691,0,0,0,210.082,38.938Z",
    transform: "translate(-164.143 -10)",
    fill: "#ffcdbe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12620",
    "data-name": "Path 12620",
    d: "M89.064,187.61a5.037,5.037,0,0,1-3.53,2.266,4.8,4.8,0,0,1-.61.039,5.982,5.982,0,0,1-3.914-1.613,11.005,11.005,0,0,1-2.962-11.052,5.776,5.776,0,0,1,3.131-3.626,5.035,5.035,0,0,1,4.19.2,1.691,1.691,0,1,1-1.479,3.042,1.67,1.67,0,0,0-1.406-.119,2.494,2.494,0,0,0-1.232,1.589,7.615,7.615,0,0,0,1.99,7.428,2.5,2.5,0,0,0,1.861.76,1.669,1.669,0,0,0,1.158-.806,1.691,1.691,0,0,1,2.8,1.895Z",
    transform: "translate(-68.835 -144.853)",
    fill: "#ffcdbe"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaking);
export default __webpack_public_path__ + "static/media/speaking.eaf31dcba00b142e93604f25d404c45a.svg";
export { ForwardRef as ReactComponent };